import { useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "../components/Logo";
import { HeartHandshake, ArrowLeft } from "lucide-react";
import TransferDetails from "../components/TransferDetails";

// Pantalla de "pago no procesado" con la alternativa de transferencia.
// El cancel_url del checkout dinámico apunta aquí.
export default function PaymentTransfer() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const plan = params.get("plan") || "pro";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-5" data-testid="payment-transfer-screen">
      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
        className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-stone-100 p-8">
        <div className="flex justify-center mb-5"><Logo size={40} /></div>
        <div className="text-center mb-5">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-brand-sage/15 flex items-center justify-center mb-4">
            <HeartHandshake className="text-brand-sageDark" size={30} />
          </div>
          <h1 className="font-outfit font-bold text-2xl text-brand-ink mb-2">No se procesó tu pago, pero no te preocupes</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Puedes pagar por transferencia bancaria y seguir disfrutando de <b>ClinPed</b>, tu expediente electrónico inteligente.
          </p>
        </div>
        <TransferDetails plan={plan} />
        <button data-testid="transfer-back-btn" onClick={() => navigate("/dashboard")}
          className="mt-5 w-full flex items-center justify-center gap-2 px-5 py-3 rounded-2xl border border-stone-200 text-brand-ink font-nunito font-semibold text-sm hover:bg-stone-50 transition-all">
          <ArrowLeft size={16} /> Volver a mi panel
        </button>
      </motion.div>
    </div>
  );
}
